import { Input, InputProps } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface TextFieldProps
  extends FieldType,
    Omit<InputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {
  checkValue?: (v: string) => boolean;
}

/**
 * Component that abstracts and simplifies the usage of Form Field component
 * for managing form input fields. It renders an Input component with the provided props.
 */
export const TextField = ({
  name,
  allowSubmit,
  readOnly,
  checkValue,
  ...props
}: TextFieldProps) => {
  const { field, helpers, inputProps, meta } = useField<string | undefined>(
    name
  );

  return (
    <Input
      {...props}
      name={name}
      value={field.value}
      onBlur={field.onBlur(name)}
      onChange={() => {
        if (meta.isError) {
          helpers.setError(undefined);
        }
      }}
      onChangeText={(v) => {
        if (!checkValue || checkValue(v)) {
          helpers.setValue(v);
        }
      }}
      {...inputProps}
      readOnly={readOnly || inputProps.readOnly}
    />
  );
};
